import React from 'react';

import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: PUBLIC_POSTHOG_HOST,
};

const SessionRecorder: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (!PUBLIC_POSTHOG_KEY) {
    console.log('='.repeat(40));
    console.log('Posthog not initialized');
    console.log('='.repeat(40));

    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};

export default React.memo(SessionRecorder);
